import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";

const Navbar = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => setScrolled(window.scrollY > 40);
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
			<div className="navbar__container">
				<a href="#inicio" className="navbar__logo-link">
					<img src={logo} alt="Dossis" className="navbar__logo" />
				</a>

				<ul
					className={`navbar__links ${menuOpen ? "navbar__links--open" : ""}`}
				>
					<li>
						<a href="#inicio" onClick={() => setMenuOpen(false)}>
							Inicio
						</a>
					</li>
					<li>
						<a href="#menu" onClick={() => setMenuOpen(false)}>
							Menú
						</a>
					</li>
					<li>
						<a href="#nosotros" onClick={() => setMenuOpen(false)}>
							Nosotros
						</a>
					</li>
					<li>
						<a href="#instagram" onClick={() => setMenuOpen(false)}>
							Instagram
						</a>
					</li>
					<li>
						<a href="#contacto" onClick={() => setMenuOpen(false)}>
							Contacto
						</a>
					</li>
				</ul>

				<a href="#contacto" className="btn btn--orange navbar__cta">
					Get your dossis!
				</a>

				<button
					className={`navbar__hamburger ${menuOpen ? "navbar__hamburger--open" : ""}`}
					onClick={() => setMenuOpen(!menuOpen)}
					aria-label="Abrir menú"
				>
					<span />
					<span />
					<span />
				</button>
			</div>
		</nav>
	);
};

export default Navbar;
